
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map, share } from 'rxjs/operators';

import { RepositoryBase } from 'app/core/base/repository.base';
import { AppInsightsService } from 'app/core/logging/appinsights.service';
import { EventShowcaseDetailDto } from 'app/models/dto';
import { ConfigurationService } from 'app/core/services/configuration.service';

@Injectable()
export class ShowcaseRepository extends RepositoryBase {

    constructor(http: HttpClient, configurationService: ConfigurationService, appInsightsService: AppInsightsService) {
        super(http, configurationService, appInsightsService);
    }

    getEvent(id: number): Observable<EventShowcaseDetailDto> {
        const url = this.ApiUri + `/showcase/event/${id}`;  // URL to web API

        return this.http.get(url).pipe(
            share(),
            map((data) => data),
            catchError((err) => this.processApiError(err)));
    }

    getEvents() {
        const url = this.ApiUri + '/showcase/events';  // URL to web API

        return this.http.get(url).pipe(
            share(),
            map((data) => data),
            catchError((err) => this.processApiError(err)));
    }

    getTeams() {
        const url = this.ApiUri + '/showcase/teams';  // URL to web API

        return this.http.get(url).pipe(
            share(),
            map((data) => data),
            catchError((err) => this.processApiError(err)));
    }
}
